import '.bu{flex-shrink:0;}.ssr-plugin'
import '.bv{padding:1rem;}.ssr-plugin'
import '.q{width:100%;}.ssr-plugin'
import '.b6{height:100%;}.ssr-plugin'
import '.bi{border:none;}.ssr-plugin'
import '.f8{background-color:transparent;}.ssr-plugin'
import '.f9{border-radius:0px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.ae{align-items:stretch;}.ssr-plugin'
import '.du{position:sticky;}.ssr-plugin'
import '.fa{top:4rem;}.ssr-plugin'
import '.fb{z-index:7;}.ssr-plugin'
import '.ah{background-color:var(--palette-white);}.ssr-plugin'
import '.fc{padding-bottom:1rem;}.ssr-plugin'
import '.a3{margin-bottom:1rem;}.ssr-plugin'
import '.fd{border-bottom:var(--border-subtle);}.ssr-plugin'
import '.w{position:fixed;}.ssr-plugin'
import '.dv{top:0px;}.ssr-plugin'
import '.b4{left:0px;}.ssr-plugin'
import '.b5{right:0px;}.ssr-plugin'
import '.fe{bottom:0px;}.ssr-plugin'
import '.ff{z-index:9999;}.ssr-plugin'
import '.fg{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.cn{justify-content:flex-end;}.ssr-plugin'
import '.bw{flex:1;}.ssr-plugin'
import '.av{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { TextLink } from '@app/components/core/link/TextLink'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="bu bv q b6 bi f8 f9"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="a e ae"
    >
      <div className="du fa fb ah fc a3 fd a"
      >
        <TextLink onClick={() => setIsOpen(true)}>{collapsedButtonLabel}</TextLink>
      </div>

      <div className="w dv b4 b5 fe ff ah fg a e"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="bv a cn fd"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="bw av">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
